import { TableDataKey } from '../types/table-data-key';
import { TableColumn } from './table-column';
import { TableDataSource } from '../providers/table-data.source';
import { TableFilterConfig } from './table-filter-config';
import { Nillable } from '@web/utils';
import { BodyRowCssClassFactory } from '../types/body-row-css-class-factory';
import { BodyRowSelectionDisabledFactory } from '../types/body-row-selection-disabled-factory';
import { ActionButton } from '../../action/models/action-button';
import { TableCollectionAction } from './table-collection-action';
import { TableItemAction } from './table-item-action';

export class TableConfig<
  Item,
  Filter = never,
  ItemAction = never,
  CollectionAction = never,
  Action = never,
> {
  public constructor(
    public readonly dataKey: TableDataKey<Item>,
    public readonly columns: TableColumn<Item, Filter>[],
    public readonly dataSource: TableDataSource<Item, Filter>,
    public readonly filters: TableFilterConfig<Filter>[],
    public readonly actions: Nillable<ActionButton<Action>[]>,
    public readonly collectionActions: Nillable<
      TableCollectionAction<Item, Filter, CollectionAction>[]
    >,
    public readonly itemActions: Nillable<TableItemAction<Item, ItemAction>[]>,
    public readonly bodyRowCssClass: Nillable<BodyRowCssClassFactory<Item>>,
    public readonly bodyRowSelectionDisabledFn: BodyRowSelectionDisabledFactory<Item>,
    public readonly filtering: boolean,
    public readonly pagination: boolean,
    public readonly preserveSelectionOnFilter: boolean,
    public readonly reordering: boolean,
    public readonly topScrollEnabled: boolean,
    public readonly scrollHeight: string,
    public readonly responsiveLayout: 'scroll' | 'stack',
  ) {}
}
